import React from 'react';

import { RouteComponentProps } from 'react-router';

import { isUserLicensed } from '@bb/users';
import { UserLocalOnboardingProfile } from '../../../types';

import { useUserOnboardingContext } from '../../../contexts/UserOnboardingContext';

import { CompleteProfileView as BaseCompleteProfileView } from '../../common/CompleteProfileView';

export type CompleteProfileViewProps = RouteComponentProps<{
  hash?: string;
}> & {
  handleGoNextStep: () => void;
};

export const CompleteProfileView = (props: CompleteProfileViewProps) => {
  const { handleGoNextStep } = props;

  const userOnboardingContext = useUserOnboardingContext();

  const handleSubmit = (values: UserLocalOnboardingProfile) => {
    userOnboardingContext.updateLocalUserProfile(values);
    handleGoNextStep();
  };

  return (
    <BaseCompleteProfileView
      initialValues={userOnboardingContext.userProfile}
      isLicensed={isUserLicensed(userOnboardingContext.userProfile)}
      handleSubmit={handleSubmit}
    />
  );
};
